import {extendPrototype} from "../../common/utils/extend";
import type {Maybe} from "./types";

extendPrototype(Number, {
    roundToDecimalPosition: function (this: number, decimalPosition: number): number {
        if (decimalPosition >= 0) {
            return Math.round(this / (10 ** decimalPosition)) * (10 ** decimalPosition);
        } else {
            return Math.round(this * (10 ** -decimalPosition)) / (10 ** -decimalPosition);
        }
    },

    lastDecimalPosition: function (this: number): number {
        const numberAsString = String(this);

        if (numberAsString.includes("e")) {
            const [significand, exponent] = numberAsString.split("e");
            return Number.parseFloat(significand).lastDecimalPosition() + Number.parseInt(exponent);
        }

        if (numberAsString.includes(".")) {
            return -numberAsString.split(".")[1].length;
        } else {
            return numberAsString.length - 1 - (lastNonZeroDecimalPositionOfIntegerString(numberAsString) ?? 0);
        }
    }
});

function lastNonZeroDecimalPositionOfIntegerString(integerAsString: string): Maybe<number> {
    for (let i = integerAsString.length - 1; i >= 0; i--) {
        if (integerAsString.charAt(i) !== "0") {
            return i;
        }
    }

    return undefined;
}

export function isNumber(value: any): value is number {
    return typeof value === "number";
}

export function clamp(value: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, value));
}

export function intFrom(string: string): number {
    const parsedNumber = Number.parseInt(string);
    if (Number.isNaN(parsedNumber)) {
        throw new TypeError(`Cannot parse integer from "${string}"`);
    }
    return parsedNumber;
}

export function floatFrom(string: string): number {
    const parsedNumber = Number.parseFloat(string);
    if (Number.isNaN(parsedNumber)) {
        throw new TypeError(`Cannot parse float from "${string}"`);
    }
    return parsedNumber;
}

declare global {
    interface Number {
        roundToDecimalPosition: (decimalPosition: number) => number;

        lastDecimalPosition: () => number;
    }
}